export interface AddUserInfo {
	firstname: string;
	lastname: string;
	email: string;
	services?: ServiceRequest[];
	organizationId: number;
	admin: boolean;
	userType: string;
}
export interface PersonRoleAndServiceRequest {
	role: string;
	services?: ServiceRequest[];
}

export interface ServiceRequest {
	id: string;
	parameters?: ParameterIdRequest[];
}

interface ParameterIdRequest {
	id: number;
	value: string;
}

export abstract class AddUserPageContent {
	abstract checkErrors(): boolean | undefined;
}
